let initialState = {
    basketCount: 0,
    notificationCount: 0,
    userInfo: {},
    userInfoStatus: {},
};

export default function UserReducer(state = initialState, action) {
    if (action.type === 'userNotificationUpdate') {
        return Object.assign({}, state, {
            basketCount: action.payload.basketCount,
            notificationCount: action.payload.notificationCount,
        });
    } else if (action.type === 'userInfo') {
        return Object.assign({}, state, {userInfo: action.payload.userInfo, userInfoStatus: action.payload.userInfoStatus});
    } else {
        return state;
    }
}
